import {onError, getImageUrl, errorHandler, logout, message, loader} from '@/libs/helper'
import {getOrganisation, leaveOrganisation} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import permissions from '@/libs/constant/permissions'
import {mapGetters} from 'vuex'

export default {
    name: 'Organisation',
    data () {
        return {
            onError,
            getImageUrl,
            metaList: [],
            isFetching: false,
            permissions: permissions
        }
    },
    computed: {
        ...mapGetters(['hasPermission'])
    },
    beforeMount() {
        if (this.hasPermission(permissions.organisationList)) this.fetchOrganisations()
    },
    methods: {
        routeToSettings (id) {
            this.$router.push({name: pageRoute.organisationSettings, params: {id}})
        },

        /**
         * fetch the list of organisations
         */
        fetchOrganisations () {
            this.isFetching = true
            getOrganisation().then(response => {
                // initialise
                this.metaList = response || []
                // set list in store
                let owners = response.filter(org => org.role === constants.ORGANISATION_RIGHTS.OWNER)
                this.$store.dispatch('setOrganisations', owners)
                this.isFetching = false
            }).catch(error => {
                this.isFetching = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * remove organisation
         * @param {*} listId list-id to be removed
         */
        leaveOrganisation (listId) {
            this.$confirm('This will permanently leave the Organisation. Continue?', 'Warning', {
                confirmButtonText: 'Remove',
                cancelButtonText: 'Cancel',
                type: 'warning',
                title: 'Leave Organisation'
                })
                .then(() => {
                    loader(this, true)
                    leaveOrganisation(listId, {}).then(response => {
                        if (response.success) {
                            this.metaList = this.metaList.filter(list => list._id !== listId);
                            this.$store.dispatch("setRefreshOrganisationList", true);
                        }
                        loader(this, false)
                    }).catch(error => {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false)  
                    })                    
                }).catch(error => {
                    console.error(error)     
                });
        },
        /**
         * route to organisation overview page
         * @param {*} organisation 
         */
        routeToOrganisationOverviewPage (organisation) {
            // route
            this.$router.push({name: pageRoute.organisationOverview, params: {id: organisation._id}})
        }
    }
}